import { motion } from 'framer-motion';

const shimmer = {
  animate: { opacity: [0.4, 0.8, 0.4] },
  transition: { duration: 1.5, repeat: Infinity, ease: "easeInOut" as const }
};

const ServiceCardSkeleton = () => {
  return (
    <div className="group relative block rounded-2xl bg-card overflow-hidden shadow-card border border-border/50">
      {/* Image Area Skeleton */}
      <div className="relative h-28 sm:h-32 md:h-36 lg:h-40 overflow-hidden flex items-center justify-center bg-muted/30">
        <div className="absolute -right-4 -top-4 h-20 w-20 rounded-full bg-primary/[0.03]" />
        <div className="absolute -left-3 -bottom-3 h-14 w-14 rounded-full bg-primary/[0.03]" />

        {/* Center icon placeholder */}
        <motion.div
          className="h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 rounded-full bg-primary/10"
          {...shimmer}
        />

        {/* Rating pill placeholder */}
        <motion.div
           className="absolute top-2 right-2 h-5 w-10 bg-primary/10 rounded-full"
           {...shimmer}
        />
        
        {/* Favorite button placeholder */}
        <motion.div
           className="absolute top-2 left-2 h-7 w-7 rounded-full bg-primary/10"
           {...shimmer}
        />
      </div>

      {/* Content Area Skeleton */}
      <div className="p-3 sm:p-3.5 md:p-4 space-y-3">
        {/* Title */}
        <motion.div className="h-4 bg-primary/10 rounded w-3/4" {...shimmer} />
        
        {/* Description (1 line) */}
        <motion.div className="h-3 bg-primary/10 rounded w-full" {...shimmer} />
        
        {/* Price & Reviews */}
        <div className="flex items-center justify-between pt-1">
          <motion.div className="h-4 bg-primary/10 rounded w-1/3" {...shimmer} />
          <motion.div className="h-3 bg-primary/10 rounded w-1/4 hidden sm:block" {...shimmer} />
        </div>
      </div>
    </div>
  );
};

export default ServiceCardSkeleton;
